import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Folder = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M3 4.00001C3 3.44773 3.44771 3.00002 4 3.00001L9.78056 3C10.0381 3 10.2857 3.09935 10.4718 3.27736L12.0031 4.74214C12.177 4.90844 12.405 5.00649 12.6453 5.01829L20.049 5.38187C20.5816 5.40802 21 5.84745 21 6.38067V7.99998C21 8.55227 20.5523 8.99998 20 8.99998L4 9C3.44772 9 3 8.55228 3 8L3 6.37859L3 4.00001Z"
        fill={color}
        fillOpacity="0.1"
      />
      <path
        d="M21 9H3V19C3 19.5523 3.44772 20 4 20L20 20C20.5523 20 21 19.5523 21 19V9Z"
        fill={color}
        fillOpacity="0.05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 2.5C3.39543 2.5 2.5 3.39543 2.5 4.5V5.57318V18.5C2.5 19.6046 3.39543 20.5 4.5 20.5L19.5 20.5C20.6046 20.5 21.5 19.6046 21.5 18.5V6.81819C21.5 5.71362 20.6046 4.81819 19.5 4.81819L12.816 4.81819C12.4768 4.81819 12.1607 4.64623 11.9765 4.36144L11.3631 3.41351C10.9945 2.84392 10.3624 2.50001 9.68396 2.50001L4.5 2.5ZM3.5 4.5C3.5 3.94772 3.94772 3.5 4.5 3.5L9.68396 3.50001C10.0232 3.50001 10.3393 3.67197 10.5235 3.95676L11.1369 4.90469C11.5055 5.47428 12.1376 5.81819 12.816 5.81819L19.5 5.81819C20.0523 5.81819 20.5 6.2659 20.5 6.81819V8.5H3.5V5.57318V4.5ZM3.5 9.5V18.5C3.5 19.0523 3.94772 19.5 4.5 19.5L19.5 19.5C20.0523 19.5 20.5 19.0523 20.5 18.5V9.5H3.5Z"
        fill={color}
      />
    </svg>
  )
})

export default Folder
